import React from "react";
import "./Inner.css";

export default function Legal({ type }) {
  const isPrivacy = type === "privacy";
  return (
    <>
      <section className="page-hero">
        <div className="container">
          <h1>{isPrivacy ? "Privacy Policy" : "Terms of Use"}</h1>
        </div>
      </section>
      <section>
        <div className="container narrow">
          <p>
            This is a placeholder {isPrivacy ? "privacy policy" : "terms of use"} page. Replace
            this text in <code>src/pages/Legal.jsx</code> with your actual{" "}
            {isPrivacy ? "privacy policy" : "terms and conditions"} before launching the site
            publicly, ideally reviewed by a legal professional familiar with healthcare data
            and financing regulations in your region.
          </p>
        </div>
      </section>
    </>
  );
}
